import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchPerformanceMonitor = async(data) => {
    try{
        const response = await gatewayInstance.post(`${SERVICE_ENDPOINT.REPORT}/reports/performance-monitor/search`,data);
        return response.data;
    }catch (error){
        console.error(error);
    }
}

export const getPerformanceSummary = async(data) => {
    try{
        const response = await gatewayInstance.post(`${SERVICE_ENDPOINT.REPORT}/reports/performance-monitor/summary`, data);
        return response.data;
    }catch (error){
        console.error(error);
    }
}